import { startCampaignListeners } from "./listeners"
import { CAMPAIGN_STATUSES, ICampaignService, ICampaignType } from "./model"
import { campaignRPO } from "./repository"

startCampaignListeners()

export const campaignSVC: ICampaignService = {
  getCampaignStatuses(): Promise<CAMPAIGN_STATUSES[]> {
    return campaignRPO.getCampaignStatuses()
  },
  getCampaignTypes(): Promise<ICampaignType[]> {
    return campaignRPO.getCampaignTypes()
  }
}
